<template>
  <div class="rs-iframe-loading">
    <RsIFrameSpin />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPartialIFrameLoadingScreen',
});
</script>

<style lang="scss">
.rs-iframe-loading {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}
</style>
